var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLightPdfUpload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97.345,
    height: 75,
    viewBox: "0 0 97.345 75",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.763,
    y1: 0.37,
    x2: 1.772,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#265df5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5dc9f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(-720 -485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(720 485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(19.244 3.025)",
    fill: "#eaeeff",
    stroke: "rgba(109,128,141,0.1)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.988,
    cy: 35.988,
    r: 35.988,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.988,
    cy: 35.988,
    r: 35.488,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 3.599,
    cy: 3.599,
    r: 3.599,
    transform: "translate(82.582 6.56)",
    fill: "#cad3ed"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 2.159,
    cy: 2.159,
    r: 2.159,
    transform: "translate(25.721 66.667)",
    fill: "#cad3ed"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 1.44,
    cy: 1.44,
    r: 1.44,
    transform: "translate(89.779 3.025)",
    fill: "#cad3ed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1_-_Outline",
    "data-name": "Union 1 - Outline",
    d: "M45.737,35.882H8.886l-.1-.012A13.133,13.133,0,0,1,1.9,32.921a12.428,12.428,0,0,1-3.8-5.65,12.12,12.12,0,0,1-.281-6.586A11.788,11.788,0,0,1,1.4,14.7l.267-.235h0l.014-.012.161-.135.006-.005.055-.045,0,0h0l.056-.046,0,0a15.786,15.786,0,0,1,6.54-3.024A17.552,17.552,0,0,1,15.272,1.006a18.246,18.246,0,0,1,5.287-2.63A19.537,19.537,0,0,1,26.369-2.5,19.211,19.211,0,0,1,36.38.266a18.469,18.469,0,0,1,3.691,2.727,18.066,18.066,0,0,1,3,3.739l.475.788.086-.01h0a2.449,2.449,0,0,1,.285-.011l.389,0,.438,0h.118c.2-.009.411-.014.614-.014a12.512,12.512,0,0,1,8.448,3.206l.328.293.006.019a14.3,14.3,0,0,1,3.8,6.265,14.489,14.489,0,0,1,.162,7.865,13.527,13.527,0,0,1-1.461,3.476,13.849,13.849,0,0,1-2.525,3.094,17.974,17.974,0,0,1-8.316,4.135ZM9.09,32.782H45.372a14.759,14.759,0,0,0,6.7-3.339,10.442,10.442,0,0,0,3.089-5.087A11.566,11.566,0,0,0,51.806,13l-.176-.157a9.368,9.368,0,0,0-6.155-2.251c-.146,0-.294,0-.442.009-.085.006-.175.006-.29.006l-.461,0-.373,0a10.823,10.823,0,0,0-4.168,1.435,13.044,13.044,0,0,0-3.672,3.217,2.379,2.379,0,0,1-1.895,1.055l-.1,0-.283-.014-.26-.11a2.988,2.988,0,0,1-.629-.361l-.177-.133-.133-.176a2.982,2.982,0,0,1,.372-3.415l0,0A19.031,19.031,0,0,1,38.331,7.4q.5-.291,1.02-.55a15,15,0,0,0-4.56-3.906l-.052-.03A16.016,16.016,0,0,0,26.369.6a16.335,16.335,0,0,0-4.857.732A15.077,15.077,0,0,0,17.142,3.5a14.529,14.529,0,0,0-5.616,8.617c-.053.225-.1.453-.146.679l-.2,1.052-1.074.185A13.186,13.186,0,0,0,3.97,16.611l-.095.077-.122.1-.006.005,0,0-.21.185A8.71,8.71,0,0,0,.9,21.4a9.073,9.073,0,0,0,.215,4.929A9.334,9.334,0,0,0,3.96,30.571,9.805,9.805,0,0,0,9.09,32.782Z",
    transform: "translate(2.501 2.5)",
    fill: "#ccd1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M68.2,32.389c13.454-.632,18.589,21.184.65,25.276H32.276c-12.221-1.528-14.468-19.183.845-21.823,3.04-15.721,23.7-17.889,31.258-5.351A16,16,0,0,0,61.8,31.7,17.35,17.35,0,0,0,56.889,36a1.351,1.351,0,0,0,.261,1.915,1.407,1.407,0,0,0,1.949-.257,14.546,14.546,0,0,1,4.119-3.607,12.473,12.473,0,0,1,4.869-1.65q.054-.006.108-.016Z",
    transform: "translate(-20.789 -20.833)",
    fill: "#e1e5f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M68.235,32.515a10.974,10.974,0,0,1,7.93,2.792c1.925,6.381-.849,14.34-10.976,16.65H28.62a11.488,11.488,0,0,1-5.933-2.488c-1.346-5.52,1.656-11.981,10.445-13.5,3.04-15.721,24.317-17.526,31.879-4.987A16.006,16.006,0,0,0,62.436,32.2a17.35,17.35,0,0,0-4.914,4.3,1.621,1.621,0,0,0-.36,1.551c.164.216.492.321.958-.278a14.546,14.546,0,0,1,4.119-3.607,12.473,12.473,0,0,1,4.869-1.65C67.154,32.51,68.191,32.524,68.235,32.515Z",
    transform: "translate(-20.8 -20.965)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M193.505,49.958c.1-5.277-12.875-8.48-18.242-.166A17.669,17.669,0,0,1,193.505,49.958Z",
    transform: "translate(-155.627 -40.43)",
    fill: "#e0e5f4",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(54.89 47.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1_-_Outline-2",
    "data-name": "Union 1 - Outline",
    d: "M30.7,23.919H5.337l-.068-.009A9.04,9.04,0,0,1,.53,21.881a8.555,8.555,0,0,1-2.613-3.889,8.343,8.343,0,0,1-.193-4.533A8.114,8.114,0,0,1,.185,9.34l.184-.162h0L.378,9.17l.111-.093,0,0,.038-.031,0,0h0l.039-.032,0,0a10.866,10.866,0,0,1,4.5-2.082A12.081,12.081,0,0,1,9.733-.086,12.559,12.559,0,0,1,13.372-1.9a13.448,13.448,0,0,1,4-.6A13.224,13.224,0,0,1,24.262-.6,12.712,12.712,0,0,1,26.8,1.281a12.436,12.436,0,0,1,2.062,2.574l.327.542.059-.007h0a1.686,1.686,0,0,1,.2-.007h.267l.3,0H30.1c.141-.006.283-.009.422-.009a8.613,8.613,0,0,1,5.815,2.207l.226.2,0,.013a9.84,9.84,0,0,1,2.612,4.313,9.973,9.973,0,0,1,.112,5.414,9.311,9.311,0,0,1-1.006,2.393,9.533,9.533,0,0,1-1.738,2.13,12.372,12.372,0,0,1-5.724,2.846ZM5.477,21.786H30.452a10.159,10.159,0,0,0,4.613-2.3,7.188,7.188,0,0,0,2.126-3.5,7.961,7.961,0,0,0-2.31-7.821l-.121-.108a6.449,6.449,0,0,0-4.236-1.549c-.1,0-.2,0-.3.006-.059,0-.12,0-.2,0l-.317,0h-.257a7.449,7.449,0,0,0-2.869.988,8.978,8.978,0,0,0-2.528,2.215,1.637,1.637,0,0,1-1.3.726l-.068,0-.195-.01-.179-.076a2.057,2.057,0,0,1-.433-.249l-.122-.091L21.656,9.9a2.053,2.053,0,0,1,.256-2.35l0,0a13.1,13.1,0,0,1,3.69-3.23q.344-.2.7-.379a10.327,10.327,0,0,0-3.139-2.688l-.036-.021A11.024,11.024,0,0,0,17.371-.366a11.244,11.244,0,0,0-3.343.5A10.378,10.378,0,0,0,11.02,1.632,10,10,0,0,0,7.154,7.563c-.037.155-.07.312-.1.468l-.14.724-.739.127a9.076,9.076,0,0,0-4.222,1.773l-.065.053-.084.071,0,0,0,0-.144.127a6,6,0,0,0-1.82,3.042,6.245,6.245,0,0,0,.148,3.393,6.425,6.425,0,0,0,1.96,2.922A6.749,6.749,0,0,0,5.477,21.786Z",
    transform: "translate(2.501 2.5)",
    fill: "#ccd1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25-2",
    "data-name": "Path 25",
    d: "M53.912,29.27c9.261-.435,12.8,14.582.447,17.4H29.187c-8.412-1.052-9.959-13.2.581-15.021,2.093-10.821,16.311-12.314,21.516-3.683a11.012,11.012,0,0,0-1.773.833,11.943,11.943,0,0,0-3.383,2.962.93.93,0,0,0,.18,1.318.969.969,0,0,0,1.342-.177,10.012,10.012,0,0,1,2.835-2.483,8.585,8.585,0,0,1,3.352-1.136l.074-.011Z",
    transform: "translate(-21.28 -21.316)",
    fill: "#e1e5f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26-2",
    "data-name": "Path 26",
    d: "M53.943,29.465A7.554,7.554,0,0,1,59.4,31.388c1.325,4.392-.584,9.871-7.555,11.461H26.675a7.907,7.907,0,0,1-4.084-1.713c-.927-3.8,1.14-8.247,7.19-9.289,2.093-10.821,16.738-12.064,21.944-3.433a11.017,11.017,0,0,0-1.773.832,11.943,11.943,0,0,0-3.383,2.962,1.116,1.116,0,0,0-.247,1.068c.113.149.338.221.659-.191A10.012,10.012,0,0,1,49.816,30.6a8.586,8.586,0,0,1,3.352-1.136C53.2,29.462,53.913,29.472,53.943,29.465Z",
    transform: "translate(-21.292 -21.515)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27-2",
    "data-name": "Path 27",
    d: "M187.82,48.32c.07-3.633-8.863-5.837-12.557-.114A12.162,12.162,0,0,1,187.82,48.32Z",
    transform: "translate(-161.747 -41.761)",
    fill: "#e0e5f4",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(75.947 19.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1_-_Outline-3",
    "data-name": "Union 1 - Outline",
    d: "M14.37,10.924H1.482l-.035,0A4.593,4.593,0,0,1-.961,9.888,4.347,4.347,0,0,1-2.288,7.912a4.239,4.239,0,0,1-.1-2.3,4.123,4.123,0,0,1,1.25-2.093l.093-.082h0l0,0,.056-.047,0,0,.019-.016h0l.02-.016h0A5.521,5.521,0,0,1,1.349,2.289,6.139,6.139,0,0,1,3.715-1.273a6.381,6.381,0,0,1,1.849-.92A6.833,6.833,0,0,1,7.6-2.5a6.719,6.719,0,0,1,3.5.967,6.459,6.459,0,0,1,1.291.954A6.319,6.319,0,0,1,13.436.729L13.6,1l.03,0h0a.856.856,0,0,1,.1,0h.33c.071,0,.144,0,.215,0a4.376,4.376,0,0,1,2.955,1.121l.115.1,0,.007a5,5,0,0,1,1.327,2.191,5.067,5.067,0,0,1,.057,2.751,4.731,4.731,0,0,1-.511,1.216,4.844,4.844,0,0,1-.883,1.082,6.286,6.286,0,0,1-2.908,1.446ZM1.553,9.84h12.69a5.162,5.162,0,0,0,2.344-1.168,3.652,3.652,0,0,0,1.08-1.779A4.045,4.045,0,0,0,16.493,2.92l-.062-.055a3.277,3.277,0,0,0-2.153-.787c-.051,0-.1,0-.154,0-.03,0-.061,0-.1,0h-.292a3.785,3.785,0,0,0-1.458.5,4.562,4.562,0,0,0-1.284,1.125.832.832,0,0,1-.663.369h-.034l-.1,0L10.1,4.033a1.045,1.045,0,0,1-.22-.126L9.82,3.86,9.773,3.8A1.043,1.043,0,0,1,9.9,2.6h0A6.656,6.656,0,0,1,11.78.962q.175-.1.357-.192A5.247,5.247,0,0,0,10.542-.6l-.018-.011A5.6,5.6,0,0,0,7.6-1.416a5.713,5.713,0,0,0-1.7.256A5.273,5.273,0,0,0,4.369-.4,5.081,5.081,0,0,0,2.4,2.613c-.019.079-.036.158-.051.238l-.071.368-.375.065a4.612,4.612,0,0,0-2.145.9l-.033.027-.043.036,0,0h0l-.073.065a3.046,3.046,0,0,0-.925,1.546,3.173,3.173,0,0,0,.075,1.724,3.265,3.265,0,0,0,1,1.485A3.429,3.429,0,0,0,1.553,9.84Z",
    transform: "translate(2.501 2.5)",
    fill: "#ccd1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25-3",
    "data-name": "Path 25",
    d: "M38.395,25.882c4.705-.221,6.5,7.409.227,8.84H25.832c-4.274-.535-5.06-6.709.3-7.632,1.063-5.5,8.287-6.257,10.932-1.871a5.6,5.6,0,0,0-.9.423,6.068,6.068,0,0,0-1.719,1.5.472.472,0,0,0,.091.67.492.492,0,0,0,.682-.09,5.087,5.087,0,0,1,1.441-1.262,4.362,4.362,0,0,1,1.7-.577Z",
    transform: "translate(-21.814 -21.841)",
    fill: "#e1e5f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26-3",
    "data-name": "Path 26",
    d: "M38.417,26.153a3.838,3.838,0,0,1,2.774.977c.673,2.232-.3,5.015-3.839,5.823H24.562a4.018,4.018,0,0,1-2.075-.87c-.471-1.931.579-4.19,3.653-4.72,1.063-5.5,8.5-6.13,11.15-1.744a5.6,5.6,0,0,0-.9.423,6.068,6.068,0,0,0-1.719,1.5.567.567,0,0,0-.126.542c.057.076.172.112.335-.1A5.087,5.087,0,0,1,36.32,26.73a4.362,4.362,0,0,1,1.7-.577C38.039,26.151,38.4,26.156,38.417,26.153Z",
    transform: "translate(-21.827 -22.113)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27-3",
    "data-name": "Path 27",
    d: "M181.643,46.54c.036-1.846-4.5-2.966-6.38-.058A6.179,6.179,0,0,1,181.643,46.54Z",
    transform: "translate(-168.396 -43.208)",
    fill: "#e0e5f4",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(41.851 17.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M3.211,0H24.695l6.21,5.87s1.07.972,1.431,1.327l4.64,4.43V41.773A3.119,3.119,0,0,1,36.033,44L36.026,44a3.232,3.232,0,0,1-2.261.923H3.211A3.23,3.23,0,0,1,.942,44,3.117,3.117,0,0,1,0,41.773V3.154A3.117,3.117,0,0,1,.942.926,3.23,3.23,0,0,1,3.211,0ZM8.155,38.951a.876.876,0,1,1,0-1.752H28.82a.876.876,0,1,1,0,1.752ZM6.716,13.195a.876.876,0,1,1,0-1.752h9.19a.876.876,0,1,1,0,1.752Zm0-6.7a.876.876,0,1,1,0-1.752h4.949a.876.876,0,1,1,0,1.752Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#ccd1e3",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M0,0H16.194V13.612H26.631V37.478H0Z",
    transform: "translate(4.024 2.829)",
    fill: "#ccd1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M3.211,0H24.695l6.21,5.87s1.07.972,1.431,1.327l4.64,4.43V41.773A3.119,3.119,0,0,1,36.033,44L36.026,44a3.232,3.232,0,0,1-2.261.923H3.211A3.23,3.23,0,0,1,.942,44,3.117,3.117,0,0,1,0,41.773V3.154A3.117,3.117,0,0,1,.942.926,3.23,3.23,0,0,1,3.211,0ZM8.155,38.951a.876.876,0,1,1,0-1.752H28.82a.876.876,0,1,1,0,1.752ZM6.716,13.195a.876.876,0,1,1,0-1.752h9.19a.876.876,0,1,1,0,1.752Zm0-6.7a.876.876,0,1,1,0-1.752h4.949a.876.876,0,1,1,0,1.752Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M33.415.277a1.173,1.173,0,0,1,.222.19l12.2,11.61H33.415Z",
    transform: "translate(-8.518 -0.277)",
    fill: "#ccd1e3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(19.425 46.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1_-_Outline-4",
    "data-name": "Union 1 - Outline",
    d: "M19.532,15.031H2.7l-.045-.006A6,6,0,0,1-.489,13.679,5.677,5.677,0,0,1-2.223,11.1,5.536,5.536,0,0,1-2.351,8.09,5.384,5.384,0,0,1-.719,5.357L-.6,5.249h0l.006-.005.073-.062,0,0,.025-.021,0,0h0l.026-.021h0A7.21,7.21,0,0,1,2.528,3.754,8.017,8.017,0,0,1,5.617-.9,8.334,8.334,0,0,1,8.032-2.1a8.924,8.924,0,0,1,2.654-.4,8.775,8.775,0,0,1,4.573,1.263A8.436,8.436,0,0,1,16.945.009a8.252,8.252,0,0,1,1.368,1.708l.217.36.039,0h0a1.119,1.119,0,0,1,.13,0h.431c.093,0,.188-.006.28-.006a5.715,5.715,0,0,1,3.859,1.464l.15.134,0,.009a6.53,6.53,0,0,1,1.733,2.862,6.618,6.618,0,0,1,.074,3.593,6.179,6.179,0,0,1-.667,1.588,6.326,6.326,0,0,1-1.154,1.413,8.21,8.21,0,0,1-3.8,1.889ZM2.793,13.616H19.366a6.741,6.741,0,0,0,3.061-1.525,4.77,4.77,0,0,0,1.411-2.323A5.283,5.283,0,0,0,22.3,4.578l-.08-.072a4.279,4.279,0,0,0-2.811-1.028c-.067,0-.134,0-.2,0-.039,0-.08,0-.133,0H18.7a4.943,4.943,0,0,0-1.9.655,5.958,5.958,0,0,0-1.677,1.47,1.086,1.086,0,0,1-.866.482h-.045l-.129-.006-.119-.05a1.365,1.365,0,0,1-.287-.165l-.081-.061-.061-.08a1.362,1.362,0,0,1,.17-1.56v0a8.693,8.693,0,0,1,2.449-2.143q.228-.133.466-.251A6.853,6.853,0,0,0,14.532-.014l-.024-.014a7.315,7.315,0,0,0-3.823-1.056A7.461,7.461,0,0,0,8.467-.75a6.886,6.886,0,0,0-2,.992A6.636,6.636,0,0,0,3.906,4.178c-.024.1-.047.207-.067.31l-.093.48-.49.085a6.023,6.023,0,0,0-2.8,1.176l-.043.035-.056.047,0,0,0,0-.1.085A3.978,3.978,0,0,0-.949,8.415a4.144,4.144,0,0,0,.1,2.252,4.263,4.263,0,0,0,1.3,1.939A4.479,4.479,0,0,0,2.793,13.616Z",
    transform: "translate(2.501 2.5)",
    fill: "#ccd1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25-4",
    "data-name": "Path 25",
    d: "M43.3,26.953c6.145-.288,8.491,9.676.3,11.545h-16.7c-5.582-.7-6.608-8.762.386-9.968C28.667,21.35,38.1,20.36,41.556,26.087a7.307,7.307,0,0,0-1.176.552A7.925,7.925,0,0,0,38.135,28.6a.617.617,0,0,0,.119.875.643.643,0,0,0,.89-.117,6.644,6.644,0,0,1,1.881-1.648,5.7,5.7,0,0,1,2.224-.754Z",
    transform: "translate(-21.645 -21.675)",
    fill: "#e1e5f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26-4",
    "data-name": "Path 26",
    d: "M43.324,27.2a5.013,5.013,0,0,1,3.622,1.275c.879,2.915-.388,6.55-5.013,7.605H25.23a5.247,5.247,0,0,1-2.71-1.137c-.615-2.521.756-5.472,4.771-6.164C28.68,21.6,38.4,20.775,41.852,26.5a7.312,7.312,0,0,0-1.176.552,7.925,7.925,0,0,0-2.245,1.965.74.74,0,0,0-.164.708c.075.1.225.147.437-.127a6.644,6.644,0,0,1,1.881-1.648A5.7,5.7,0,0,1,42.81,27.2C42.831,27.2,43.3,27.2,43.324,27.2Z",
    transform: "translate(-21.658 -21.924)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27-4",
    "data-name": "Path 27",
    d: "M183.6,47.1c.047-2.41-5.881-3.873-8.332-.076A8.07,8.07,0,0,1,183.6,47.1Z",
    transform: "translate(-166.294 -42.751)",
    fill: "#e0e5f4",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "cloud-upload",
    transform: "translate(769.045 519.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M18.977,17.337l-3.658-3.658L11.66,17.337l.918.918,2.092-2.092-.026,7.542h1.3l.026-7.542,2.092,2.092Z",
    transform: "translate(-4.458 -7.312)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M16.7,7.025V6.966a5.841,5.841,0,1,0-11.681,0v.1A4.96,4.96,0,0,0,2.472,8.393a4.437,4.437,0,0,0-1.347,3.181A4.719,4.719,0,0,0,2.586,14.96a4.93,4.93,0,0,0,3.409,1.416H8.588v-1.3H6a3.632,3.632,0,0,1-3.572-3.5A3.432,3.432,0,0,1,5.714,8.283l.6-.043V6.966a4.543,4.543,0,1,1,9.086,0v1.3l.641.008a3.2,3.2,0,0,1,3.253,3.3A3.367,3.367,0,0,1,16,15.078H13.131v1.3H16a4.452,4.452,0,0,0,3.291-1.438,4.913,4.913,0,0,0,1.3-3.364A4.492,4.492,0,0,0,16.7,7.025Z",
    fill: "url(#linear-gradient)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLightPdfUpload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/light_pdf_upload.3344d9661e79dc687b2a62a975fe8e74.svg";